import { connect } from 'react-redux';
import { ImportRetry } from '../../components/pages/survey-admin/ImportRetry';
import { IApplicationState } from '../../store';
import { ActionCreators as SurveyAdminStoreActionCreators } from '../../store/SurveyAdminStore';

export const ImportRetryPage: React.ComponentType<{ surveyId: number }> = connect(
	(state: IApplicationState) => ({
		importRetryModel: state.surveyAdmin.importRetryModel,
		isSendingRequest: state.surveyAdmin.isSendingRequest,
		audiences: [...state.surveyAdmin.audiences],
	}),
	{ ...SurveyAdminStoreActionCreators },
)(ImportRetry);
